import { IReportNhapHocRequest } from "../../model/request/report/IReportNhapHocRequest";
import { apiClient } from "../apiClient";
export const REPORT_NHAPHOC_ENDPOINT = "report-nhap-hoc";

export const reportNhapHocApi = {
  SelectByPaging: (request: IReportNhapHocRequest) =>
    apiClient.post(`${REPORT_NHAPHOC_ENDPOINT}/tong-hop`, request),

  ExportExcel: (request: IReportNhapHocRequest) =>
    apiClient.post(`${REPORT_NHAPHOC_ENDPOINT}/export-excel`, request),
};
